
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0(1|3|80)|245|599|715|726)|2(1(30|39|46)|2(26|76|80|93)|469|497|503|651|663)|5(058|073|111|362|45|519|675|781|87)|6(5(14|38|60)|7(17|51|62)|044|10|282|317|386|477|964|973)|1(293|311|413|837|940|987)|8(9(17|75|89|91)|2(11|28|6)|[06]89|004|454|726|76|85|860)|7(51[02]|(|29|34)2|(46|47|88|99)3|016|167|719|744)|3(4(06|58|59|79)|5(2|49|65|72)|027|058|230|304|342|622|796|866|87|901|960)|9(8(19|67|78)|2(36|42|6|72)|6(|39|93)|150|352|383|409|456|506|522)|0)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
